import { useSearchParams } from "react-router-dom";
import DropshipReturnsPanel from "../../../dropship/DropshipReturnsPanel";
import ClaimsTab from "./ClaimsTab";

/**
 * ClaimsOrReturnsSeller — pill switcher between Claims and Returns.
 * Delegates rendering to `ClaimsTab` or `DropshipReturnsPanel`. Uses a
 * URL param (?view=returns) so refreshing keeps state.
 * Extracted from SellerDropship.jsx in Phase 6 refactor.
 */
export default function ClaimsOrReturnsSeller({ orders, reload }) {
  const [search, setSearch] = useSearchParams();
  const view = search.get("view") === "returns" ? "returns" : "claims";
  const setView = (v) => {
    const next = new URLSearchParams(search);
    next.set("tab", "claims");
    if (v === "returns") next.set("view", "returns"); else next.delete("view");
    setSearch(next, { replace: true });
  };
  return (
    <div className="space-y-5" data-testid="claims-or-returns-seller">
      <div className="flex items-center gap-1.5" data-testid="claims-returns-toggle-seller">
        <button
          onClick={() => setView("claims")}
          data-testid="toggle-claims-seller"
          className={`text-[12.5px] mono uppercase tracking-[0.16em] px-4 py-1.5 rounded-full border transition-all ${view === "claims" ? "bg-foreground text-background border-transparent" : "bg-white border-border text-foreground/60 hover:border-foreground/40"}`}
        >Claims</button>
        <button
          onClick={() => setView("returns")}
          data-testid="toggle-returns-seller"
          className={`text-[12.5px] mono uppercase tracking-[0.16em] px-4 py-1.5 rounded-full border transition-all ${view === "returns" ? "bg-foreground text-background border-transparent" : "bg-white border-border text-foreground/60 hover:border-foreground/40"}`}
        >Returns</button>
      </div>
      {view === "claims"
        ? <ClaimsTab reload={reload}/>
        : <DropshipReturnsPanel role="seller" orders={orders} reload={reload}/>}
    </div>
  );
}
